import React from 'react';
import classnames from 'classnames';
import { FormControlLabel } from '@material-ui/core';
import { Checkbox } from '@Components/common';
import styles from './KeyPersonRoleSelect.module.scss';
import { useTranslation } from 'react-i18next';

interface KeyPersonRoleSelectProps {
  name: string;
  description: string;
  value: boolean;
  checked: boolean;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required: boolean;
  inputRef?: React.Ref<any>;
}

export const KeyPersonRoleSelect = ({
  name,
  description,
  value,
  checked,
  disabled = false,
  onChange,
  inputRef,
  required,
}: KeyPersonRoleSelectProps) => {
  const { t } = useTranslation('account');

  return (
    <div
      className={classnames(
        styles.tileWrapper,
        checked && styles.tileWrapperChecked,
        required && styles.tileWrapperRequired,
      )}
    >
      <FormControlLabel
        className={styles.label}
        control={
          <Checkbox
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            inputRef={inputRef}
            value={value}
          />
        }
        name={name}
        labelPlacement="bottom"
        label={
          <div className={styles.descriptionWrapper}>
            <strong>{name}</strong>
            {!disabled ? (
              <div className={styles.description}>{description}</div>
            ) : (
              <div className={styles.description}>
                {t('tabs.organization.key_people.roles.representative.already_exists_error')}
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};
